import { ImpactType } from '../impact';
import { ProjectUpdateWithProject, ProjectWithPublicMetadata } from '../projects';
import type { CertificationLevel } from '@prisma/client';

export type { ProjectUpdateWithProject, ProjectWithPublicMetadata } from '../projects';

export type UserAppStatus = 'unregistered' | 'legacy' | 'phoenix';

export interface ImpactTotalsData {
  totals: Record<ImpactType, number>;
  pendingTotals: Record<ImpactType, number>;
}

export interface ImpactHubData {
  userId: string;
  name: string;
  blurb?: string;
  city?: string;
  country?: string;
  createdAt?: Date;
  certificationLevel?: CertificationLevel;
  impact: ImpactTotalsData & {
    projects: Array<ProjectWithPublicMetadata>;
    projectUpdates: Array<ProjectUpdateWithProject>;
  };
  group?: {
    id: number;
    name: string;
    logoImageKey?: string | null;
    createdAt?: Date;
  };
  config?: Partial<{
    displayName: string;
    logoUrl: string;
    linkUrl: string;
    blurb: string;
    location: string;
    showMemberSince: boolean;
    showWorkforceShowcase: boolean;
  }>;
  workforce?: {
    employeeCount: number;
    monthsOfClimateAction: number;
    isPaused: boolean;
    monthlyImpact: Record<ImpactType, number>;
  };
}

export type PhoenixDashboardData = {
  impact: ImpactTotalsData & {
    projects: Array<ProjectWithPublicMetadata>;
    projectUpdates: Array<ProjectUpdateWithProject>;
  };
};
